import defaultTo from 'lodash/defaultTo'
import isEmpty from 'lodash/isEmpty'

export default endSubscriptionCtrl

/** @ngInject */
function endSubscriptionCtrl($scope, $state, $stateParams, $q, Contract, ContractService, ContractStatus, AdwordsService, gaEventsService, ErrorCatcher, userInfo, contractDraft, isDepositNeeded) {
    // Selected Contract State
    $scope.contract = null
    $scope.paymentAccepted = false
    $scope.transaction = {
        transactionStatus: $stateParams.transactionStatus,
        transactionErrorCode: $stateParams.transactionErrorCode,
        signatureOperationResult: $stateParams.signatureOperationResult,
        transactionId: defaultTo($stateParams.transactionId, $stateParams.order_reference),
    }

    // View state
    $scope.displayForm = false
    $scope.state = 'state-initial'
    $scope.hasRetractationBypassed = false
    $scope.hasRefGoalBypassed = false
    $scope.userInfo = userInfo

    $scope.updateViewState = function (action) {
        if (action === 'RETRACTION-FORM-FINISHED') {
            $scope.hasRetractationBypassed = true
        } else if (action === 'GOAL-FORM-FINISHED') {
            $scope.hasRefGoalBypassed = true
        }

        if (isEmpty($scope.contract.id)) {
            $scope.state = 'state-error-no-contract'
        } else if (!$scope.paymentAccepted) {
            $scope.state = 'state-error-payment-refused'
        } else if (!$scope.hasRetractationBypassed) {
            $scope.state = 'state-end-retraction-form'
        } else if (!$scope.hasRefGoalBypassed) {
            $scope.state = 'state-end-goal-form'
        } else {
            $scope.state = 'state-end-finish'
        }
    }

    const activate = function () {
        const transactionContractId = defaultTo($scope.transaction.transactionId, '').split('-')[0]
        const transactionContract = ContractService.findContract(userInfo.contracts, transactionContractId)
        const initialContract = ContractService.findFirstGoalNotDefinedContract(userInfo.contracts)

        // Update status on found contract
        if (!isEmpty(transactionContract)) {
            $scope.contract = transactionContract
            $scope.paymentAccepted = true
            gaEventsService.newEvent('page - Confirmation Souscription Success - Slimplay + Initial Contract')
        } else if ($scope.transaction.transactionStatus === 'success') {
            $scope.contract = { id: transactionContractId }
            $scope.paymentAccepted = true
            $scope.hasRetractationBypassed = true
            $scope.hasRefGoalBypassed = true
            gaEventsService.newEvent('page - Confirmation Souscription Success - Slimplay + No Initial Contract')
        } else if (($scope.transaction.transactionStatus === 'failure') || ((contractDraft.id === transactionContractId) && contractDraft.ready_to_checkout)) {
            $scope.contract = { id: transactionContractId }
            $scope.paymentAccepted = false
            gaEventsService.newEvent('page - Confirmation Souscription Fail - Payment Refused')
        } else if (isEmpty(transactionContractId) && !isEmpty(initialContract)) {
            $scope.contract = initialContract
            $scope.paymentAccepted = true
            gaEventsService.newEvent('page - Confirmation Souscription Success - No Slimpay + Initial Contract')
        } else {
            $scope.contract = {}
            $scope.paymentAccepted = false
            gaEventsService.newEvent('page - Confirmation Souscription None - No Slimpay + No Initial Contract')
        }

        // Fire tracking
        if (!isEmpty($scope.contract.id)) {
            AdwordsService.fireSlimpaySuccessRedirect($scope.contract.id)
            if (window.fbq) {
                window.fbq('track', 'CompleteRegistration')
            }
            if (window.uetq) {
                window.uetq.push({
                    ec: 'Souscription', // Event category
                    ea: 'Fin de souscription', // Event action
                    el: $scope.contract.id, // Event label
                })
            }
        }

        // If transactionContractId undefined,
        // check security deposit for the first selected contract
        let isDepositNeededPromise
        if (!isEmpty(isDepositNeeded.contractId) || isEmpty($scope.contract.id)) {
            isDepositNeededPromise = $q.resolve({ depositNeeded: false })
        } else {
            isDepositNeededPromise = Contract.isDepositNeeded({ id: $scope.contract.id }).$promise
        }
        isDepositNeededPromise.then((result) => {
            if (result.depositNeeded) {
                $state.go('securityDepositAuthenticated', { contractId: $scope.contract.id })
            } else {
                // Update which state to display
                $scope.updateViewState()
                $scope.displayForm = true
            }
        }).catch((error) => {
            ErrorCatcher.catchError(error)
        })
    }

    // Controller Activation Promises
    // https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#controller-activation-promises
    activate()
}



// WEBPACK FOOTER //
// ./src/states/endSubscription/endSubscription.js